class QuantityInput extends HTMLElement {
  constructor() {
    super();
    /** @type {HTMLInputElement} */
    this.input = /** @type {HTMLInputElement} */ (this.querySelector("input"));
    this.input.addEventListener("change", () => {
      console.log("change event in quantity-input");
    });

    this.changeEvent = new Event("change", { bubbles: true });
    this.isMainForm = false;
    this.productId = this.dataset.productId || "";
    this.vendor = this.dataset.vendor || "";
    this.line = parseInt(this.dataset.line || "");
    // console.log(`initializing quantity input for product ${this.productId} rendered in cart: ${this.isRenderedInCart}, value: ${this.input.value}`);

    this.productLimit = store.getLimitForProduct(parseInt(this.productId));
    this.brandLimit = store.getLimitForBrand(this.vendor);
    if (
      !this.productLimit &&
      !this.brandLimit &&
      window.enableGlobalProductLimit
    ) {
      this.productLimit = window.globalProductLimit;
    }
    this.hasLimit = this.productLimit || this.brandLimit ? true : false;

    this.limitType = (() => {
      if (!this.productLimit && !this.brandLimit) return "none";
      if (this.productLimit) return "product";
      if (this.brandLimit) return "brand";
    })();
    this.limitReached = false;

    this.plusButtonDisabled = false;

    // Store the event handler so it can be properly removed
    /** @type {EventListener} */
    this.preventPlusClickHandler = (event) => {
      event.preventDefault();
      event.stopPropagation();
    };

    // console.log('limitType: ', this.limitType);
    // console.log('productLimit: ', this.productLimit);
    // console.log('brandLimit: ', this.brandLimit);

    messenger.listen(
      messenger.topics.CHECK_LIMITS,
      /** @param {Cart} cart **/ (cart) => {
        if (!this.hasLimit) return;
        this.checkLimits(cart);
      }
    );

    this.debouncedQtyChange = knocking.debounce((line, quantity) => {
      const res = store.updateCartQuantity(this.line, quantity);
      return res;
    }, 300);
  }

  connectedCallback() {
    // console.log("Connected callback in quantity-input base-class");
    this.init();
    /** @type {HTMLButtonElement | undefined} */
    this.buyButton = undefined;
    this.checkMinusButtonStatus(parseInt(this.input.value));
    this.enablePlusButton();
    this.initialValue = parseInt(this.input.value);
    if (!this.initialValue) {
      console.error(
        "Could not determine initial value for quantity-selector..."
      );
    }
  }

  init() {
    console.log("cant init abstract class");
  }

  /** @param {number} qty */
  checkMinusButtonStatus(qty) {
    // if (this.isRenderedInCart) {
    //   return;
    // }
    if (qty == 1) {
      this.disableMinusButton();
    } else {
      this.enableMinusButton();
    }
  }

  // temporary fix for the limit-notice behaviour, keeping the old one for reference
  disablePlusButton() {
    this.plusButtonDisabled = true;
    const plusBtn = this.querySelector('button[name="plus"]');
    if (!plusBtn) {
      console.log("plus button not found");
      return;
    }
    plusBtn.addEventListener("click", this.preventPlusClickHandler);
  }
  enablePlusButton() {
    this.plusButtonDisabled = false;
    const plusBtn = this.querySelector('button[name="plus"]');
    if (!plusBtn) {
      console.log("plus button not found");
      return;
    }
    plusBtn.removeEventListener("click", this.preventPlusClickHandler);
  }

  // disablePlusButton(greyOutSvg = true) {
  //   /** @type {HTMLButtonElement | null} */
  //   const plusBtn = this.querySelector('[name="plus"]');
  //   if (!plusBtn) return;

  //   plusBtn.disabled = true;
  //   if (greyOutSvg) {
  //     const svg = plusBtn.querySelector("svg");
  //     if (svg) {
  //       svg.classList.add("disabled");
  //     }
  //   }
  // }

  // enablePlusButton() {
  //   /** @type {HTMLButtonElement | null} */
  //   const plusBtn = this.querySelector('[name="plus"]');
  //   if (plusBtn) {
  //     plusBtn.disabled = false;
  //   }
  // }

  disableMinusButton(greyOutSvg = true) {
    /** @type {HTMLButtonElement | null} */
    const minusBtn = this.querySelector('[name="minus"]');
    if (!minusBtn) return;

    minusBtn.disabled = true;

    if (greyOutSvg) {
      const svg = minusBtn.querySelector("svg");
      if (svg) {
        svg.classList.add("disabled");
      }
    }
  }

  enableMinusButton() {
    /** @type {HTMLButtonElement | null} */
    const minusBtn = this.querySelector('[name="minus"]');
    if (minusBtn) {
      minusBtn.disabled = false;
    } else {
      console.error("minus button not found");
    }
  }
}

class QuantityInputPP extends QuantityInput {
  constructor() {
    super();
  }

  init() {
    this.hasCustomText = this.dataset.hasCustomText === "true" ? true : false;
    // console.log('initializing PP quantity input - has limit: ', this.hasLimit);
    window.addEventListener(
      "message",
      (event) => {
        if (event.data.type === "product_form_ready") {
          this.formId = this.input.id.replace("Quantity-template--", "");
          if (this.formId.includes("main")) {
            this.isMainForm = true;
            /**
             * @type {HTMLButtonElement | null}
             */
            this.buyButton = document.querySelector(".product-form__submit");
            this.checkMinusButtonStatus(parseInt(this.input.value));

            if (this.hasLimit) {
              this.checkLimits();
            }
          } else {
            this.isMainForm = false;
            return;
          }
          this.form = document.querySelector(
            `form[id="product-form-template--${this.formId}"]`
          );
        }
      },
      false
    );

    this.querySelectorAll("button").forEach((button) => {
      button.addEventListener("click", this.onButtonClick.bind(this));
    });

    this.querySelectorAll("button").forEach((button) => {
      button.addEventListener("keydown", (event) => {
        console.log("keydown event", event);
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          event.stopPropagation();
          this.onButtonClick(event);
        }
      });
    });

    if (this.hasLimit) {
      this.checkLimits();
    }

    messenger.listen(
      messenger.topics.CHECK_LIMITS,
      /** @param {Cart} cart */ (cart) => {
        // console.log('CHECK_LIMITS event received', cart);
        if (!this.hasLimit) {
          return;
        }
        this.checkLimits(cart);
      }
    );

    messenger.listen(messenger.topics.RESET_PRODUCT_FORM, () => {
      this.input.value = "1";
    });
  }

  /**
   * @param {Cart | null} cart
   */
  async checkLimits(cart = null) {
    // const value = parseInt(this.input.value);
    if (!cart) {
      cart = await store.getCart();
    }
    const value = 1;
    // console.log('checking limit on PP for: ', this.productId, 'value: ', value);
    const limitStatus = await knocking.returnLimitStatus(
      cart,
      parseInt(this.input.value) - 1,
      this.productId,
      this.vendor
    );
    if (!limitStatus) {
      return;
    }
    this.updateLimitsUi(limitStatus, value);
  }

  /**
   * @param {MouseEvent | KeyboardEvent} event
   */
  async onButtonClick(event) {
    event.preventDefault();
    event.stopPropagation();

    const target = /** @type {HTMLButtonElement} */ (event.target);
    target.name === "plus" ? this.input.stepUp() : this.input.stepDown();

    const value = parseInt(this.input.value);

    this.checkMinusButtonStatus(value);

    if (!this.hasLimit) {
      return;
    }

    const limitStatus = await knocking.returnLimitStatus(
      null,
      value,
      this.productId,
      this.vendor
    );

    if (!limitStatus) {
      console.log("no limitStatus available...");
      return;
    }
    this.updateLimitsUi(limitStatus, value);
  }

  /**
   * @param {number} value
   */
  checkMinusButtonStatus(value) {
    if (value === 1) {
      this.disableMinusButton();
    } else {
      this.enableMinusButton();
    }
  }

  /**
   * @param {Limit} limitStatus
   * @param {number} value
   */
  updateLimitsUi(limitStatus, value) {
    if (limitStatus.remainingQty - value === 0) {
      // console.log('updating limits ui case 1');
      this.disablePlusButton();
      this.enableBuyButton();
    } else if (limitStatus.remainingQty - value < 0) {
      // console.log('updating limits ui case 2');
      this.disableBuyButton();
      this.disablePlusButton();
      messenger.emmit(messenger.topics.PP_LIMIT_MESSAGE_SHOW, {
        productId: this.productId,
        limitStatus,
      });
    } else {
      // console.log('updating limits ui case 3');
      this.enableBuyButton();
      this.enablePlusButton();
      messenger.emmit(messenger.topics.PP_LIMIT_MESSAGE_HIDE, {
        productId: this.productId,
      });
    }
  }

  disableBuyButton() {
    if (!this.buyButton) {
      return;
    }
    this.buyButton.removeAttribute("type");
    this.buyButton.setAttribute("disabled", true);
    this.buyButton.classList.add("disabled");
  }

  enableBuyButton() {
    if (!this.buyButton) {
      return;
    }

    const expiredHolidayShippingPresent = this.checkForHolidayShippingExpired();
    if (!expiredHolidayShippingPresent && !this.hasCustomText) {
      // console.log('enabling buy button from qty-input-pp');
      this.buyButton.setAttribute("type", "submit");
    }
    this.buyButton.removeAttribute("disabled");
    this.buyButton.classList.remove("disabled");
  }

  /**
   * @param {number} qty
   */
  checkPlusButtonStatus(qty, limitReached = false) {
    if (limitReached || qty == this.productLimit) {
      this.disablePlusButton();
    }
  }

  checkForHolidayShippingExpired() {
    /**
     * @type {HTMLElement | null}
     */
    const holidayShippingExpiredContainer = document.querySelector(
      ".holiday-shipping-expired-container"
    );
    // console.log('holidayShippingExpiredContainer', holidayShippingExpiredContainer);
    if (
      holidayShippingExpiredContainer &&
      holidayShippingExpiredContainer.style.display === "block"
    ) {
      return true;
    }
    return false;
  }
}

class QuantityInputCart extends QuantityInput {
  constructor() {
    super();
  }

  async init() {
    // console.log('initializing cart quantity input');
    this.querySelectorAll("button").forEach((button) => {
      button.addEventListener("click", this.onButtonClick.bind(this));
    });

    this.querySelectorAll("button").forEach((button) => {
      button.addEventListener("keydown", (event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          event.stopPropagation();
          this.onButtonClick(event);
        }
      });
    });

    messenger.listen(
      messenger.topics.CART_READY,
      async () => {
        const cart = await store.getCart();
        const limitStatus = await knocking.returnLimitStatus(
          cart,
          null,
          this.productId,
          this.vendor
        );
        if (!limitStatus) {
          console.log("no limitStatus available...");
          return;
        }
        this.updateLimitsUi(limitStatus);
      },
      "QuantityInput"
    );
  }

  /**
   * @param {MouseEvent | KeyboardEvent} event
   * */
  async onButtonClick(event) {
    console.log("onButtonClick");
    console.log("plus button disabled: ", this.plusButtonDisabled);
    event.preventDefault();
    event.stopPropagation();

    /** @type {HTMLButtonElement | null} */
    const target = /** @type {HTMLButtonElement | null} */ (event.target);
    const name = target && target.name ? target.name : null;
    if (!name) {
      console.error("Could not determine plus/minus...missing name attribute!");
      return;
    }
    messenger.emmit(messenger.topics.RESET_PRODUCT_FORM, null);

    let diffQuantity = 0;
    diffQuantity = name === "plus" ? 1 : -1;

    if (name === "plus" && !this.plusButtonDisabled) {
      this.input.stepUp();
    } else if (name === "minus") {
      this.input.stepDown();
    } else {
      console.log("no button action...returning");
      return;
    }

    this.checkMinusButtonStatus(parseInt(this.input.value));

    const limitStatus = await knocking.returnLimitStatus(
      null,
      diffQuantity,
      this.productId
    );
    console.log("limitStatus in quantity-input: ", limitStatus);

    // If there's no limit, just update the cart
    if (!this.hasLimit) {
      console.log("No limite, updating cart...");
      const res = await this.debouncedQtyChange(this.line, this.input.value);
      if (!res) {
        console.error("No response,might be sold out, resetting...");
        this.input.value = this.initialValue?.toString() || "1";
        return;
      }
      messenger.emmit(messenger.topics.UPDATE_TOTAL_PRICE, res);
      messenger.emmit(messenger.topics.UPDATE_CART_ITEMS, res);

      return;
    }

    const inputQty = parseInt(this.input.value);

    if (
      limitStatus &&
      this.initialValue &&
      limitStatus.remainingQty - (inputQty - this.initialValue) < 0
    ) {
      console.log("returning early and updating limits ui");
      this.updateLimitsUi(limitStatus);

      return;
    }

    // Debouncing the quantity change to avoid multiple requests
    const res = await this.debouncedQtyChange(this.line, this.input.value);
    if (!res) {
      console.error(
        "No response,might be sold out, resetting...",
        this.initialValue
      );
      this.input.value = this.initialValue ? this.initialValue.toString() : "1";
      return;
    }
    console.log("res in quantity-input: ", res);
    if (!res) {
      console.log("No response from quantity-change, aborting...");
      return;
    }

    messenger.emmit(messenger.topics.UPDATE_TOTAL_PRICE, res);
    messenger.emmit(messenger.topics.UPDATE_CART_ITEMS, res);

    const newLimitStatus = await knocking.returnLimitStatus(
      res,
      0,
      this.productId
    );
    console.log("newLimitStatus", newLimitStatus);

    if (!newLimitStatus) {
      console.log("no limitStatus available...");
      return;
    }
    this.updateLimitsUi(newLimitStatus);
    messenger.emmit(messenger.topics.UPDATE_CART_ITEMS, res);

    // Setting the input value to the value returned by the API
    this.input.value = res.items[this.line - 1].quantity;
    this.initialValue = res.items[this.line - 1].quantity;
  }

  /**
   * @param {Cart} cart
   */
  async checkLimits(cart) {
    const limitStatus = await knocking.returnLimitStatus(
      cart,
      0,
      this.productId
    );
    if (!limitStatus) {
      console.log("no limitStatus available...");
      return;
    }
    this.limtReached = limitStatus.limitReached;
    this.updateLimitsUi(limitStatus);
  }

  /**
   * @param {number} qty
   */
  checkMinusButtonStatus(qty) {
    if (qty === 1) {
      this.disableMinusButton();
    } else {
      this.enableMinusButton();
    }
  }

  /**
   * @param {Limit} limitStatus
   */
  updateLimitsUi(limitStatus) {
    // console.log('updateLimitsUi in cart qty-input', limitStatus, changeType);
    if (!limitStatus) {
      return;
    }
    if (limitStatus.remainingQty === 0) {
      // console.log('Qty-cart updating limits ui case 1');
      this.disablePlusButton();
      messenger.emmit(messenger.topics.PP_LIMIT_MESSAGE_SHOW, {
        productId: this.productId,
        limitStatus,
      });
    } else if (limitStatus.remainingQty < 0) {
      // console.log('Qty-cart updating limits ui case 2');
      this.disablePlusButton();
      messenger.emmit(messenger.topics.PP_LIMIT_MESSAGE_SHOW, {
        productId: this.productId,
        limitStatus,
      });
    } else if (limitStatus.remainingQty > 0) {
      // console.log('Qty-cart updating limits ui case 3');
      this.enablePlusButton();
      messenger.emmit(messenger.topics.PP_LIMIT_MESSAGE_HIDE, {
        productId: this.productId,
        limitStatus,
      });

      return;
    }
  }
}

customElements.define("quantity-input", QuantityInput);
customElements.define("quantity-input-pp", QuantityInputPP);
customElements.define("quantity-input-cart", QuantityInputCart);
